<template>
    <div>
        <div class="d-flex justify-content-between align-items-center">
            <h2>{{ $t('eventRegistration.payment.coupon') }} {{ currentCoupon.couponId }}</h2>
            <base-button size="sm" type="danger" @click="$emit('remove')">
                {{$t('eventRegistration.payment.remove')}}
            </base-button>
        </div>
        <h4 class="mb-0">{{ $t('eventRegistration.payment.redeemedAmount') }}</h4>
        <div class="h1">{{ redeemedAmount }} {{ currencySymbol }}</div>
        <h5 class="mb-0">{{ $t('eventRegistration.payment.remainingAmount') }}</h5>
        <div class="h4">{{ remainingAmount }} {{ currencySymbol }}</div>
    </div>
</template>

<script>
import registrationPriceMixin from "@/mixins/registration/registrationPriceMixin";

export default {
    name: "CouponToRedeem",
    mixins: [registrationPriceMixin],
    props: {
        coupons: {
            type: Array,
            required: true
        },
        index: {
            type: Number,
            required: true
        },
        invoiceTotal: {
            type: Number,
            required: true
        },
        alreadyRedeemedAmount: {
            type: Number,
            required: true
        }
    },
    computed: {
        currentCoupon() {
            return this.coupons[this.index]
        },
        totalAfterSubtractingPreviousCoupons() {
            let total = this.invoiceTotal - this.alreadyRedeemedAmount
            for (let i = 0; i < this.index; i++) {
                total -= this.coupons[i].amount
            }
            return total;
        },
        redeemedAmount() {
            return Math.min(this.totalAfterSubtractingPreviousCoupons, this.currentCoupon.amount)
        },
        remainingAmount() {
            return this.currentCoupon.amount - this.redeemedAmount
        }
    }
}
</script>

<style scoped>

</style>
